//import Alert from 'bootstrap/js/dist/alert'
//import Button from 'bootstrap/js/dist/button'
//import Carousel from 'bootstrap/js/dist/carousel'
import Collapse from "bootstrap/js/dist/collapse";
//import Dropdown from 'bootstrap/js/dist/dropdown'
//import Offcanvas from 'bootstrap/js/dist/offcanvas'
//import Popover from 'bootstrap/js/dist/popover'
//import ScrollSpy from 'bootstrap/js/dist/scrollspy'
//import Tab from 'bootstrap/js/dist/tab'
//import Toast from 'bootstrap/js/dist/toast'
//import Tooltip from 'bootstrap/js/dist/tooltip'
import once from '@drupal/once'
import AOS from 'aos';
import { jarallax, jarallaxElement } from 'jarallax';
jarallaxElement();

var $component = once("processed", ".component-story-full").shift();
if ($component) {
  import("../../templates/component/story-menu/js/story-menu");
}
var $component = once("processed", ".component-garant-featured").shift();
if ($component) {
  import("../../templates/component/garant-featured/js/garant-featured");
}
var $component = once("processed", ".component-garant-modal").shift();
if ($component) {
  import("../../templates/component/garant-modal/js/garant-modal");
}
var $component = once("processed", ".component-research-list").shift();
if ($component) {
  import("../../templates/component/research-list/js/research-list");
}
var $component = once("processed", ".component-story-list").shift();
if ($component) {
  import("../../templates/component/story-list/js/story-list");
}
var $component = once("processed", ".component-contact").shift();
if ($component) {
  import("../../templates/component/contact/js/contact");
}
var $component = once("processed", ".component-story-featured").shift();
if ($component) {
  import("../../templates/component/story-featured/js/story-featured");
}
var $component = once("processed", ".component-story-related").shift();
if ($component) {
  import("../../templates/component/story-related/js/story-related");
}
var $component = once("processed-styleguide", "body.styleguide").shift();
if ($component) {
  import("../../src/js/styleguide");
}
var $component = once("processed", "body").shift();
if ($component && typeof ccnstL !== "undefined") {
  import("../../templates/component/cookieconsent/js/cookieconsent");
}

document.querySelectorAll('.js-jarallax').forEach(function (element) {
  jarallax(element, {
    type: 'element',
    speed: element.getAttribute('data-jarallax-speed'),
  });
});

AOS.init({
  offset: 10,
  duration: 600,
  delay: 100,
  once: true,
});
